import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import { toastError, toastSuccess } from "../../../common/Toast";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "jspdf-autotable";
import { Box, Button } from "@mui/material";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { Stack } from "react-bootstrap";
import { handleSaveColumnOrder } from "../../../common/common";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";

const AccountsReceivableAgingDetail = (props) => {
  const searchParams = new URLSearchParams(window.location.search);
  const token = localStorage.getItem("Token");
  const loginuserid = localStorage.getItem("ID");
  const locationid = localStorage.getItem("Location");
  let navigate = useNavigate();
  let iParam = searchParams.get("custid") || 0;
  let iStartDate = searchParams.get("startdate") || "";
  let iEndDate = searchParams.get("enddate") || "";
  let iselectedTransactionType = searchParams.get("selectedTransactionType") || 0;
  let iselectReport = searchParams.get("selectReport") || 0;
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [totalbalance, setTotalBalance] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(6);
  const [agingPeriod, setAgingPeriod] = useState(30);
  const [numberPeriod, setNumberPeriod] = useState(4);
  const [mindayspastdue, setMindayspastdue] = useState(0);
  const [columnOrder, setColumnOrder] = useState([]);
  const [customerDropdown, setcustomerDropdown] = useState([]);
  const [customerid, setcustomerid] = useState(0);
  const [saletype, setSaletype] = useState([]);
  const [selectedTransactionType, setSelectedTransactionType] = useState(0);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [apiCalled, setApiCalled] = useState(false);
  const handleDropdownChange = (event) => {
    // const selectedValue = event.target.value;
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  console.log(iParam, iStartDate, iEndDate, iselectedTransactionType, iselectReport, "params");
  console.log(responseData, "responseDataccc");
  

  const apicall = () => {
    console.log(agingPeriod, numberPeriod, mindayspastdue, "parametersvvvvvv");
    let SDate = startdate !== "" ? startdate : iStartDate;
    let EDate = enddate !== "" ? enddate : iEndDate;
    let currCustomerId = customerid !== 0 ? customerid : iParam;
    let currSelectedTransactionType = selectedTransactionType !== 0 ? selectedTransactionType : iselectedTransactionType;
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/receivableagingdetail?startdate=${SDate}&enddate=${EDate}&daysperagingperiod=${agingPeriod}&numberofperiods=${numberPeriod}&mindayspastdue=${mindayspastdue}&loginId=${loginuserid}&locationid=${locationid}&customerid=${currCustomerId}&transactiontype=${currSelectedTransactionType}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          const FilterData = res.data.ResponseData?.list?.map((el) => ({
            ...el,
            OpenBalance: Number(el?.OpenBalance),
            Amount: Number(el?.Amount),
          }));
          setResponseData(FilterData);
          // setDataResponse(res.data.ResponseData.Periods);
          setTotalSum(
            FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.Amount) || 0),
              0
            )
          );
          setTotalBalance(
            FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.OpenBalance) || 0),
              0
            )
          );
          navigate("/accounts-receivable-aging-detail");

          console.log("11", responseData);
          setColumnOrder(
            res.data.ResponseData?.ColumnOrder?.length > 0
              ? res.data.ResponseData?.ColumnOrder.split(",")
              : ["mrt-row-select", ...columns.map((c) => c.accessorKey)]
          );

          // const keysToSetFalse = res.data.ResponseData?.ColumnsHide.length || "" ;
          const keysToSetFalse =
            res.data.ResponseData?.ColumnsHide.length > 0
              ? res.data.ResponseData?.ColumnsHide
              : ["mrt-row-select", ...columns.map((c) => c.accessorKey)];
          console.log(keysToSetFalse, "keysToSetFalse");
          // Create default object with all values set to true
          const obj = columns.reduce((acc, item) => {
            acc[item.accessorKey] = true;
            return acc;
          }, {});

          // Comma-separated string of keys to set to false

          // Convert the string to an array and set the corresponding keys in the object to false
          keysToSetFalse.split(",").forEach((key) => {
            if (obj.hasOwnProperty(key)) {
              obj[key] = false;
            }
          });

          console.log(obj, "checkobj");

          setColumnVisibility(obj);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  if (iParam > 0 && apiCalled === false) {    
    setStartDate(iStartDate);
    setEndDate(iEndDate);
    setcustomerid(iParam);
    setSelectedTransactionType(Number(iselectedTransactionType));
    setSelectReport(Number(iselectReport));
    apicall();
    setApiCalled(true);
  }

  // useEffect(() => {
  //   if (
  //     (agingPeriod === undefined || agingPeriod === "") &&
  //     (numberPeriod === undefined || numberPeriod === "")
  //   ) {
  //     toastError("Days per aging period or Number of periods can't be empty");
  //     return;
  //   } else if (agingPeriod === undefined || agingPeriod === "") {
  //     toastError("Please enter a number between 1 to 500");
  //     return;
  //   } else if (numberPeriod === undefined || numberPeriod === "") {
  //     toastError("Please enter a number between 1 to 50");
  //     return;
  //   } else {
  //     apicall();
  //   }
  // }, [startdate, enddate, agingPeriod, numberPeriod, mindayspastdue]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/getalltransactiontype?isshowviewregister=3`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const transactionType = res.data.ResponseData.map((u) => ({
          label: u.Name,
          value: u.ID,
        }));
        setSaletype(transactionType);
        console.log("res280", res.data.ResponseData);
      });

    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        const customerData = res.data.ResponseData.map((u) => ({
          label: u.CompanyName,
          value: u.Id,
        }));
        setcustomerDropdown(customerData);
        return res;
      });
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      size: 110,
      Cell: ({ row }) => {
        const Date = row?.original?.Date;
        if (Date === "0000-00-00" || Date === "" || Date === null) {
          return "";
        }
        return moment(Date).format(`${dateFormate.toUpperCase()}`);
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            const url =
              row.original?.TransactionType === "Payment"
                ? `/receive-payment/${row.original.TxnID}`
                : row.original?.TransactionType === "Invoice" ||
                  row.original?.TransactionType === "Return/ Memo"
                ? `/sales-receipt/${row.original.TxnID}`
                : row.original?.TransactionType === "Journal Entry"
                ? `/journal-entry/${row.original.TxnID}`
                : row.original?.TransactionType === "Deposit"
                ? `/bank-deposit/${row.original.TxnID}`
                : `/Expense/${row.original.TxnID}`;

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.TransactionType}
        </Box>
      ),
    },
    {
      header: "Num",
      accessorKey: "Num",
      size: 110,
    },
    {
      header: "Customer",
      accessorKey: "Customer",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      size: 110,
      Cell: ({ row }) => {
        const DueDate = row?.original?.DueDate;
        if (DueDate === "0000-00-00" || DueDate === "" || DueDate === null) {
          return "";
        }
        return moment(DueDate).format(`${dateFormate.toUpperCase()}`);
      },
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: 120,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.Amount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
      Footer: () => (
        <>
          <div style={{ textAlign: "end" }}>
            <Stack>
              Total:
              <Box color="warning.main">
                {CurrencySymbols(
                  Number(totalSum),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </Box>
            </Stack>
          </div>
        </>
      ),
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      size: 120,
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row.original.OpenBalance),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
      Footer: () => (
        <>
          <div style={{ textAlign: "end" }}>
            <Stack>
              Total:
              <Box color="warning.main">
                {CurrencySymbols(
                  Number(totalbalance),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </Box>
            </Stack>
          </div>
        </>
      ),
    },
    {
      header: "Create Date",
      accessorKey: "CreateDate",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      size: 120,
    },
    {
      header: "Last Modified",
      accessorKey: "LastModified",
      Cell: ({ row }) => {
        const LastModified = row?.original?.LastModified;
        if (
          LastModified === "0000-00-00" ||
          LastModified === "" ||
          LastModified === null
        ) {
          return "";
        }
        return moment(LastModified).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedBy",
      size: 120,
    },
    {
      header: "Phone",
      accessorKey: "Phone",
      size: 120,
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    {
      header: "FullName",
      accessorKey: "FullName",
    },
    {
      header: "Billing Address",
      accessorKey: "BillingAddress",
    },
    {
      header: "Shipping Address",
      accessorKey: "ShippingAddress",
    },
    {
      header: "Company Name",
      accessorKey: "CompanyName",
    },
    {
      header: "Ship Date",
      accessorKey: "ShipDate",
    },
    {
      header: "Ship Via",
      accessorKey: "ShipVia",
    },
    {
      header: "Tracking",
      accessorKey: "Tracking",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
    },
    {
      header: "Client/ Vendor Message",
      accessorKey: "ClientVendorMessage",
    },
    {
      header: "Past Due",
      accessorKey: "DaysPastDue",
    },
    {
      header: "Delivery Address",
      accessorKey: "DeliveryAddress",
    },
    {
      header: "Memo Description",
      accessorKey: "MemoDescription",
    },
    {
      header: "Aging Period",
      accessorKey: "AgingPeriod",
    },
  ]);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Accounts Receivable Aging Detail
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label form-label p-lg-medium">
                Report period
              </label>
              <Select
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                options={reportdropdown}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                name="Reportperiod"
                id="Reportperiod"
                value={reportdropdown.find((e) => e.value === selectReport)}
                onChange={(event) => {
                  handleDropdownChange(event);
                }}
                className="custom-search-select"
              ></Select>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
              </div>
            )}
            <div className="col-sm-2 ">
              <label className="col-form-label form-label">
                Days per aging period
              </label>
              <input
                className="form-control"
                name="agingperiod"
                id="agingperiod"
                value={agingPeriod}
                onChange={(e) => {
                  setAgingPeriod(e.target.value);
                }}
              ></input>
            </div>
            <div className="col-sm-2 ">
              <label className="col-form-label form-label">
                Number of periods
              </label>
              <input
                className="form-control"
                name="numberperiod"
                id="numberperiod"
                value={numberPeriod}
                onChange={(e) => {
                  setNumberPeriod(e.target.value);
                }}
              ></input>
            </div>
            <div className="col-sm-2 ">
              <label className="col-form-label form-label">
                Min. Days Past Due
              </label>
              <input
                className="form-control"
                name="numberperiod"
                id="numberperiod"
                onChange={(e) => {
                  setMindayspastdue(e.target.value);
                }}
              ></input>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label form-label p-lg-medium">
                Transaction Type
              </label>
              <Select
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                options={saletype}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                isClearable={true}
                onChange={(event) =>
                  setSelectedTransactionType(event ? event.value : 0)
                }
                value={
                  saletype.find((e) => e.value === selectedTransactionType) ||
                  0
                }
                className="custom-search-select"
              />
            </div>
            <div className="col-sm-3">
              <label className="col-form-label form-label p-lg-medium">
                Customer
              </label>
              <Select
                options={customerDropdown}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                isClearable={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                onChange={(event) => setcustomerid(event?.value || 0)}
                value={customerDropdown.find((e) => e.value == customerid) || 0}
                className="custom-select-search"
              />
            </div>
            {/* <div
              className="cursor-pointer col-md-3 d-flex justify-content-end mt-5"
              onClick={() =>
                handleSaveColumnOrder(
                  loginuserid,
                  "AccountPayableSummaryReport",
                  columnOrder,
                  token,
                  columnVisibility
                )
              }
              title="Lock Your Sequence"
            >
              <i class="fa fa-lock columnsLock fs-4"></i>
            </div> */}
            <div className="col">
              {/* align-self-sm-end */}
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                {""}
              </label>
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <h6 className="fw-bold p-regular">
                      {" "}
                      Accounts Receivable Aging Detail
                    </h6>
                    <div className="row mb-2">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Accounts Receivable Aging Detail"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={["AgingPeriod"]}
                    columnsVisibility={{
                      CreateDate: false,
                      CreatedBy: false,
                      LastModified: false,
                      LastModifiedBy: false,
                      Phone: false,
                      Email: false,
                      FullName: false,
                      BillingAddress: false,
                      ShippingAddress: false,
                      CompanyName: false,
                      ShipDate: false,
                      ShipVia: false,
                      Tracking: false,
                      Terms: false,
                      ClientVendorMessage: false,
                      DaysPastDue: false,
                      DeliveryAddress: false,
                      MemoDescription: false,
                    }}
                    // setColumnOrder={setColumnOrder}
                    enableRowSelection={false}
                    enableExpandAll={true}
                    enableExpanding={true}
                    expanded={true}
                    // setColumnVisibility={setColumnVisibility}
                    // state={{
                    //   columnOrder,
                    //   columnVisibility,
                    // }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountsReceivableAgingDetail;
